import axios, { AxiosResponse } from 'axios';
import { TopConfig } from '../context/ConfigContext';
import { PingSession } from '../types/services';

export const pingSession = async (topConfig: TopConfig) => {
    const { url, method, headers } = topConfig.services.pingSession;

    if (!url) {
        throw new Error('Ping session service: Url not defined');
    }

    try {
        const response: AxiosResponse<PingSession> = await axios(url, {
            method,
            headers
        });

        if (response.status === 200) {
            return true;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};
